import React, { useEffect } from 'react';
import BasicSelector from '../Basic/BasicSelector';

import { types } from 'constants/vesselTypes';

function TypesGeneral({
    typeGeneral, countIndex, changeFieldsMultiple, required = false, setHasErrors, 
}) {
    const handleChange = (value) => {
        const toChange = [
            {
                index: countIndex,
                field: 'typeByPurpose',
                value,
            },
        ];

        if (value !== typeGeneral) {
            toChange.push(
                {
                    index: countIndex,
                    field: 'vesselId',
                    value: null,
                },
                {
                    index: countIndex,
                    field: 'vessel.imoNumber',
                    value: '',
                },
                {
                    index: countIndex,
                    field: 'vesselDwtGroup',
                    value: {},
                },
            );
        }
        changeFieldsMultiple(toChange);
    };

    useEffect(() => {
        if (required) {
            if (!typeGeneral) {
                setHasErrors('typeGeneral', true);
            } else {
                setHasErrors('typeGeneral', false);
            }
        }
    }, [typeGeneral]);

    return (
        <BasicSelector 
            value={typeGeneral}
            dataList={types}
            onChange={(e, _i, value) => handleChange(value)}
            style={{ fontSize: '9px' }}
            underlineStyle={{ display: 'none' }}
            iconStyle={{ display: 'none' }}
            labelStyle={{ padding: 0, top: 'unset' }}
            fields={['name']}
        />
    );
}

export default React.memo(TypesGeneral);



// WEBPACK FOOTER //
// ./app/components/TcIndex/RowData/TypeGeneral.jsx